module.exports = __webpack_public_path__ + "assets/img/closeModal_new_error.4705527f.svg";